import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MaintenanceGuard } from "./maintenance/maintenance.guard";
import { MaintenancePage } from "./maintenance/maintenance.page";


const routes: Routes = [
    {
        path: "",
        redirectTo: "account/login",
        pathMatch: "full"
    },
    {
        path: "account",
        loadChildren: "./account/account.module#AccountModule"
    },
    {
        path: "admin",
        loadChildren: "./admin/admin.module#AdminModule"
    },
    {
        path: "error",
        loadChildren: "./error/error.module#ErrorModule"
    },
    {
        path: "maintenance",
        data: { title: "Maintenance" },
        component: MaintenancePage,
        canActivate: [MaintenanceGuard]
    },
    {
        path: "**",
        redirectTo: "error/not-found"
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { useHash: false, enableTracing: false, onSameUrlNavigation: "reload" })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }

export const guards = [MaintenanceGuard];
export const pages = [MaintenancePage];